import type { Locale } from "./domain";

const copy = {
  ar: {
    account: "حسابي",
    add: "أضف",
    address: "عنوان التوصيل",
    all: "الكل",
    cached: "نسخة محفوظة — الطلب متوقف حتى عودة الشبكة",
    cancel: "إلغاء الطلب",
    cart: "السلة",
    checkout: "مراجعة الطلب",
    closed: "مغلق الآن",
    favorites: "المفضلة",
    grocery: "ماركت",
    home: "الرئيسية",
    locate: "استعمل موقعي",
    login: "تسجيل الدخول",
    markAllRead: "تعليم الكل كمقروء",
    next: "متابعة",
    noNotifications: "لا إشعارات بعد",
    noResults: "لا توجد نتائج في منطقتك",
    notifications: "الإشعارات",
    offline: "أنت دون اتصال",
    open: "مفتوح",
    orders: "طلباتي",
    pharmacy: "صيدلية",
    placeOrder: "تأكيد الطلب",
    reorder: "أعد الطلب",
    reorderClosed: "المتجر مغلق حالياً — راجع سلتك وأكّد عندما يفتح",
    reorderPartial: "بعض الأصناف لم تعد متوفرة، أضفنا المتاح منها",
    reorderUnavailable: "أصناف هذا الطلب لم تعد متوفرة",
    restaurant: "مطاعم",
    search: "ابحث عن مطعم أو أكلة",
    shop: "متاجر",
    total: "الإجمالي",
    track: "تتبع الطلب",
  },
  fr: {
    account: "Compte",
    add: "Ajouter",
    address: "Adresse de livraison",
    all: "Tout",
    cached: "Copie enregistrée — commande suspendue hors ligne",
    cancel: "Annuler",
    cart: "Panier",
    checkout: "Vérifier",
    closed: "Fermé",
    favorites: "Favoris",
    grocery: "Courses",
    home: "Accueil",
    locate: "Ma position",
    login: "Se connecter",
    markAllRead: "Tout marquer lu",
    next: "Continuer",
    noNotifications: "Aucune notification",
    noResults: "Aucun résultat dans votre zone",
    notifications: "Notifications",
    offline: "Hors ligne",
    open: "Ouvert",
    orders: "Commandes",
    pharmacy: "Pharmacie",
    placeOrder: "Confirmer la commande",
    reorder: "Commander à nouveau",
    reorderClosed: "Le magasin est fermé — vérifiez le panier et confirmez à l’ouverture",
    reorderPartial: "Certains articles ne sont plus disponibles; nous avons ajouté le reste",
    reorderUnavailable: "Les articles de cette commande ne sont plus disponibles",
    restaurant: "Restaurants",
    search: "Restaurant ou plat",
    shop: "Boutiques",
    total: "Total",
    track: "Suivre",
  },
} as const;

export type TranslationKey = keyof typeof copy.ar;
export const tr = (locale: Locale, key: TranslationKey) => copy[locale][key];
